import { createContext, useContext, type ReactNode } from "react";
import type { CatalogMeta, Model, Provider } from "../types";
import {
  catalogMeta as seedMeta,
  models as seedModels,
  providers as seedProviders,
} from "../data";

export interface CatalogData {
  models: Model[];
  providers: Provider[];
  meta: CatalogMeta;
  fromApi: boolean;
}

const CatalogDataContext = createContext<CatalogData>({
  models: seedModels,
  providers: seedProviders,
  meta: seedMeta,
  fromApi: false,
});

export function CatalogDataProvider({
  value,
  children,
}: {
  value: CatalogData;
  children: ReactNode;
}) {
  return (
    <CatalogDataContext.Provider value={value}>{children}</CatalogDataContext.Provider>
  );
}

export function useCatalogData(): CatalogData {
  return useContext(CatalogDataContext);
}

export function useCatalogModel(id: string | undefined): Model | undefined {
  const { models } = useCatalogData();
  return id ? models.find((m) => m.id === id) : undefined;
}

export function useCatalogProvider(id: string | undefined): Provider | undefined {
  const { providers } = useCatalogData();
  return id ? providers.find((p) => p.id === id) : undefined;
}
